import { render, staticRenderFns } from "./AddexamCyclePage.vue?vue&type=template&id=4fa8c172&"
import script from "./AddexamCyclePage.vue?vue&type=script&lang=js&"
export * from "./AddexamCyclePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports